export const MyAccountStaticData = {
  myAccountText: 'Profile & Availability',
  setAvailabilityText: 'Set Availability',
  editInformationText: 'Edit Information',
  personalInformationText: 'Personal Information',
  firstNameText: 'First Name',
  lastNameText: 'Last Name',
  genderText: 'Gender',
  currentLocationText: 'Current Location',
  phoneNumberText: 'Phone Number',
  documentText: 'Document',
  dobText: 'Date of Birth',
  registrationOnText: 'Registration On',
  educationBackgroundText: 'Education Background',
  highestQualificationText: 'Highest Qualification',
  acadminTranscriptText: 'Academic Transcript',
  degreeNameText: 'Degree Name',
  instituteText: 'Institute',
  yearsText: 'Years',
  cvText: 'CV',
  areaOfSpecializationText: 'Area of Specialization',
  levelToTeachText: 'Levels to Teach',
  subjectsText: 'Subjects',
  languageText: 'Language',
  notificationsText: 'Notifications',
  emailNotificationText: 'Email Notifications',
  emailNotificationDescriptionText: 'Get updates about new sessions',
  pushNotificationText: 'Push Notifications',
  pushNotificationDescriptionText: 'Receive instant updates',
  manageAccountsText: 'Manage Accounts',
  walletText: 'Wallet',
  genderPreferenceText: 'Gender Prefernces',
  passwordManagerText: 'Password Manager',
  languagePreferenceText: 'Language',
  passwordResetMessageText: 'Password reset successful.',
  changePasswordText: 'Change Password',
  currentPasswordText: 'Current Password',
  currentPasswordPlaceholderText: 'Enter your current password',
  newPasswordText: 'New Password',
  newPasswordPlaceholderText: 'Enter your new password',
  confirmPasswordText: 'Confirm Password',
  confirmPasswordPlaceholderText: 'Retype your Password',
  cancelButtonText: 'Cancel',
  changePasswordButtonText: 'Change Password',
  genderPreferenceSuccessMessageText: 'Gender preference updated successfully',
  genderPreferenceFailedMessageText: 'Failed to update gender preference',
  genderPreferenceModalText: 'Gender Preferences',
  selectGenderText: 'Select the gender of students who can book your sessions.',
  haveSelectedText: 'You have selected',
  preferredStudentText:
    'as your preferred student gender. Only these students can book your sessions.',
  maleText: 'Male',
  femaleText: 'Female',
  bothText: 'Both',
  confirmText: 'Confirm',
  profileImageSuccessMessageText: 'Profile image updated successfully.',
  profileImageFailedMessageText: 'Failed to update profile image.',
  profileUpdateSuccessMessageText: 'Teachers profile updated successfully.',
  profileUpdateFailedMessageText: 'Failed to update profile',
  cvUpdateSuccessMessageText: 'CV updated successfully',
  cvUpdateFailedMessageText: 'Failed to update CV',
  cvSelectedMessageText: 'CV file selected successfully',
  cvSelectionFailedMessageText: 'Failed to select CV file',
  attachFilesText: 'Attach Files',
  saveText: 'Save',
  cancelText: 'Cancel',
  editInputPlaceholderText: 'Enter here',
};

export const MyAccountHindiData = {
  myAccountText: 'प्रोफ़ाइल & उपलब्धता',
  setAvailabilityText: 'उपलब्धता सेट करें',
  editInformationText: 'जानकारी संपादित करें',
  personalInformationText: 'व्यक्तिगत जानकारी',
  firstNameText: 'पहला नाम',
  lastNameText: 'अंतिम नाम',
  genderText: 'लिंग',
  currentLocationText: 'वर्तमान स्थान',
  phoneNumberText: 'फ़ोन नंबर',
  documentText: 'दस्तावेज़',
  dobText: 'जन्म तिथि',
  registrationOnText: 'पंजीकरण तिथि',
  educationBackgroundText: 'शैक्षिक पृष्ठभूमि',
  highestQualificationText: 'सर्वोच्च योग्यता',
  acadminTranscriptText: 'शैक्षणिक प्रतिलिपि',
  degreeNameText: 'डिग्री का नाम',
  instituteText: 'संस्थान',
  yearsText: 'वर्ष',
  cvText: 'सीवी',
  areaOfSpecializationText: 'विशेषज्ञता का क्षेत्र',
  levelToTeachText: 'शिक्षण स्तर',
  subjectsText: 'विषय',
  languageText: 'भाषा',
  notificationsText: 'सूचनाएँ',
  emailNotificationText: 'ईमेल सूचनाएँ',
  emailNotificationDescriptionText: 'नए सत्रों के बारे में अपडेट प्राप्त करें',
  pushNotificationText: 'पुश सूचनाएँ',
  pushNotificationDescriptionText: 'तत्काल अपडेट प्राप्त करें',
  manageAccountsText: 'खाता प्रबंधन',
  walletText: 'बटुआ',
  genderPreferenceText: 'लिंग वरीयता',
  passwordManagerText: 'पासवर्ड प्रबंधक',
  languagePreferenceText: 'भाषा',
  passwordResetMessageText: 'पासवर्ड रीसेट सफल हुआ।',
  changePasswordText: 'पासवर्ड बदलें',
  currentPasswordText: 'वर्तमान पासवर्ड',
  currentPasswordPlaceholderText: 'अपना वर्तमान पासवर्ड दर्ज करें',
  newPasswordText: 'नया पासवर्ड',
  newPasswordPlaceholderText: 'अपना नया पासवर्ड दर्ज करें',
  confirmPasswordText: 'पासवर्ड की पुष्टि करें',
  confirmPasswordPlaceholderText: 'अपना पासवर्ड फिर से टाइप करें',
  cancelButtonText: 'रद्द करें',
  changePasswordButtonText: 'पासवर्ड बदलें',
  genderPreferenceSuccessMessageText: 'लिंग प्राथमिकता सफलतापूर्वक अपडेट की गई',
  genderPreferenceFailedMessageText: 'लिंग प्राथमिकता अपडेट करने में विफल',
  genderPreferenceModalText: 'लिंग प्राथमिकताएँ',
  selectGenderText: 'उन छात्रों का लिंग चुनें जो आपके सत्र बुक कर सकते हैं।',
  haveSelectedText: 'आपने चयन किया है',
  preferredStudentText:
    'को अपनी पसंदीदा छात्र लिंग के रूप में। केवल ये छात्र आपके सत्र बुक कर सकते हैं।',
  maleText: 'पुरुष',
  femaleText: 'महिला',
  bothText: 'दोनों',
  confirmText: 'पुष्टि करें',
  profileImageSuccessMessageText: 'प्रोफ़ाइल छवि सफलतापूर्वक अपडेट की गई।',
  profileImageFailedMessageText: 'प्रोफ़ाइल छवि अपडेट करने में विफल।',
  profileUpdateSuccessMessageText: 'प्रोफ़ाइल सफलतापूर्वक अपडेट किया गया',
  profileUpdateFailedMessageText: 'प्रोफ़ाइल अपडेट करने में विफल',
  cvUpdateSuccessMessageText: 'सीवी सफलतापूर्वक अपडेट किया गया',
  cvUpdateFailedMessageText: 'सीवी अपडेट करने में विफल',
  cvSelectedMessageText: 'सीवी फ़ाइल सफलतापूर्वक चुनी गई',
  cvSelectionFailedMessageText: 'सीवी फ़ाइल चुनने में विफल',
  attachFilesText: 'फाइलें अटैच करें',
  saveText: 'सहेजें',
  cancelText: 'रद्द करें',
  editInputPlaceholderText: 'यहाँ दर्ज करें',
};

export const MyAccountArabicData = {
  myAccountText: 'الملف الشخصي والتوفر',
  setAvailabilityText: 'تحديد التوفر',
  editInformationText: 'تعديل المعلومات',
  personalInformationText: 'المعلومات الشخصية',
  firstNameText: 'الاسم الأول',
  lastNameText: 'اسم العائلة',
  genderText: 'الجنس',
  currentLocationText: 'الموقع الحالي',
  phoneNumberText: 'رقم الهاتف',
  documentText: 'الوثيقة',
  dobText: 'تاريخ الميلاد',
  registrationOnText: 'تاريخ التسجيل',
  educationBackgroundText: 'الخلفية التعليمية',
  highestQualificationText: 'أعلى مؤهل',
  acadminTranscriptText: 'كشف الدرجات الأكاديمي',
  degreeNameText: 'اسم الدرجة',
  instituteText: 'المعهد',
  yearsText: 'السنوات',
  cvText: 'السيرة الذاتية',
  areaOfSpecializationText: 'مجال التخصص',
  levelToTeachText: 'المستويات التدريسية',
  subjectsText: 'المواد',
  languageText: 'اللغة',
  notificationsText: 'الإشعارات',
  emailNotificationText: 'إشعارات البريد الإلكتروني',
  emailNotificationDescriptionText: 'احصل على تحديثات حول الجلسات الجديدة',
  pushNotificationText: 'الإشعارات الفورية',
  pushNotificationDescriptionText: 'تلقي التحديثات الفورية',
  manageAccountsText: 'إدارة الحسابات',
  walletText: 'المحفظة',
  genderPreferenceText: 'تفضيلات الجنس',
  passwordManagerText: 'مدير كلمات المرور',
  languagePreferenceText: 'اللغة',
  passwordResetMessageText: 'تم إعادة تعيين كلمة المرور بنجاح.',
  changePasswordText: 'تغيير كلمة المرور',
  currentPasswordText: 'كلمة المرور الحالية',
  currentPasswordPlaceholderText: 'أدخل كلمة المرور الحالية',
  newPasswordText: 'كلمة المرور الجديدة',
  newPasswordPlaceholderText: 'أدخل كلمة المرور الجديدة',
  confirmPasswordText: 'تأكيد كلمة المرور',
  confirmPasswordPlaceholderText: 'أعد كتابة كلمة المرور',
  cancelButtonText: 'إلغاء',
  changePasswordButtonText: 'تغيير كلمة المرور',
  genderPreferenceSuccessMessageText: 'تم تحديث تفضيل الجنس بنجاح',
  genderPreferenceFailedMessageText: 'فشل في تحديث تفضيل الجنس',
  genderPreferenceModalText: 'تفضيلات الجنس',
  selectGenderText: 'اختر جنس الطلاب الذين يمكنهم حجز جلساتك.',
  haveSelectedText: 'لقد اخترت',
  preferredStudentText: 'كجنس الطلاب المفضل لديك. يمكن لهؤلاء الطلاب فقط حجز جلساتك.',
  maleText: 'ذكر',
  femaleText: 'أنثى',
  bothText: 'كلاهما',
  confirmText: 'تأكيد',
  profileImageSuccessMessageText: 'تم تحديث صورة الملف الشخصي بنجاح.',
  profileImageFailedMessageText: 'فشل في تحديث صورة الملف الشخصي.',
  profileUpdateSuccessMessageText: 'تم تحديث ملف المعلم الشخصي بنجاح.',
  profileUpdateFailedMessageText: 'فشل في تحديث الملف الشخصي',
  cvUpdateSuccessMessageText: 'تم تحديث السيرة الذاتية بنجاح',
  cvUpdateFailedMessageText: 'فشل في تحديث السيرة الذاتية',
  cvSelectedMessageText: 'تم اختيار ملف السيرة الذاتية بنجاح',
  cvSelectionFailedMessageText: 'فشل في اختيار ملف السيرة الذاتية',
  attachFilesText: 'إرفاق الملفات',
  saveText: 'حفظ',
  cancelText: 'إلغاء',
  editInputPlaceholderText: 'أدخل هنا',
};
